import * as actionTypes from './_actionTypes';
import { updateObject, deepCloneObject } from '../utility';
import { roleStringStart } from './actions';

const initialState = {
	drawerOpen: null,
	modelUsers: [],
	modelUsersFiltered: [],
	roleString: null,
	error: null,
	loading: false,
	esos: [],
	messages: [],
};

/**
 * addMessage
 * displays string to messageDispatch component for site-wide information
 * @param {*} state
 * @param {*} action
 */
const addMessage = (state, action) => {
	const messageKeyId = action.message.Key;
	let messageDetails = action.message.Value;

	let newMessages = [...state.messages];
	if (!(newMessages && newMessages.length > 0)) {
		newMessages = [];
	}
	newMessages.push({
		type: messageKeyId,
		text: messageDetails,
	});

	//deduplicate repeated messages
	newMessages = newMessages.filter(
		(value, index, self) =>
			index ===
			self.findIndex(t => t.text === value.text && t.type === value.type)
	);

	window.scrollTo({ top: 0, behavior: 'auto' });

	return updateObject(state, {
		messages: newMessages,
	});
};

/**
 * clearMessage
 * remove a message by index from state
 * @param {*} state
 * @param {*} action
 */
const clearMessage = (state, action) => {
	let newMessages = [...state.messages];

	if (
		action &&
		action.message &&
		typeof action.message.messageIndex === 'number' &&
		action.message.messageIndex >= 0 &&
		action.message.messageIndex < newMessages.length
	) {
		newMessages.splice(action.message.messageIndex, 1);
	}
	return updateObject(state, { messages: newMessages });
};

/**
 * clearMessages
 * remove all messages from state
 * @param {*} state
 * @param {*} action
 */
const clearMessages = (state, action) => {
	return updateObject(state, { messages: [] });
};

/**
 * Case reducer.
 * Performs filtration on `modelUsersFiltered` state, comparing the value of cell `Name` against @param action's payload.
 *
 * @function
 * @param {Object} state current state object.
 * @param {Object} action dispatched action object. Property `payload` equals filtration criteria.
 * @returns {Object} updated state object.
 */
const filterModelAfter = (state, action) => {
	const filter = action.payload ? action.payload.toLowerCase() : '';

	let modelUsersCopy = deepCloneObject(state.modelUsers);
	modelUsersCopy = modelUsersCopy.filter(model =>
		model.Cells['Name'].Value.toLowerCase().includes(filter)
	);

	return updateObject(state, {
		modelUsersFiltered: modelUsersCopy,
	});
};

const modelAfterStart = state => {
	return updateObject(state, {
		modelUsers: [],
		modelUsersFiltered: [],
		error: null,
		loading: true,
	});
};

const modelAfterFail = (state, action) => {
	return updateObject(state, { error: action.error, loading: false });
};

const modelAfterSuccess = (state, action) => {
	return updateObject(state, {
		modelUsers: action.payload,
		modelUsersFiltered: action.payload,
		error: null,
		loading: false,
	});
};

const clearModelAfterResults = state => {
	return updateObject(state, {
		modelUsers: [],
		modelUsersFiltered: [],
		error: null,
		loading: false,
	});
};

const updateEsosStart = state => {
	return updateObject(state, { error: null, loading: true });
};

const updateEsosFail = (state, action) => {
	return updateObject(state, { error: action.error, loading: false });
};

const updateEsosSuccess = (state, action) => {
	return updateObject(state, {
		error: null,
		loading: false,
		esos: action.esos,
	});
};

const toggleDrawer = (state, action) => {
	return updateObject(state, {
		drawerOpen: action.payload
	})
}

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.ADD_MESSAGE:
			return addMessage(state, action);
		case actionTypes.CLEAR_MESSAGE:
			return clearMessage(state, action);
		case actionTypes.CLEAR_MESSAGES:
			return clearMessages(state, action);
		case actionTypes.MODELAFTER_FILTER:
			return filterModelAfter(state, action);
		case actionTypes.MODELAFTER_START:
			return modelAfterStart(state, action);
		case actionTypes.MODELAFTER_SUCCESS:
			return modelAfterSuccess(state, action);
		case actionTypes.MODELAFTER_FAIL:
			return modelAfterFail(state, action);
		case actionTypes.CLEAR_MODELAFTER_RESULTS:
			return clearModelAfterResults(state, action);
		case actionTypes.ROLESTRING_START:
			return roleStringStart(state, action);
		case actionTypes.UPDATE_ESOS_START:
			return updateEsosStart(state, action);
		case actionTypes.UPDATE_ESOS_SUCCESS:
			return updateEsosSuccess(state, action);
		case actionTypes.UPDATE_ESOS_FAIL:
			return updateEsosFail(state, action);
		case actionTypes.TOGGLE_DRAWER:
			return toggleDrawer(state, action);
		default:
			return state;
	}
};

export default reducer;
